module.exports = __webpack_public_path__ + "static/media/tzuk_farm_thumb_even.1eea4d62.webp";